import React, { FC, useState } from 'react';

const getSizeByFile = (file?: File) => {
  if (!file) return '0 Byte';
  const bytes = file.size;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (bytes === 0) return '0 Byte';
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  return `${parseFloat((bytes / 1024 ** i).toFixed(2))} ${sizes[i]}`;
};

type AttachFileProps = {
  setValue?: (name: string, value?: unknown[]) => void;
};

export const AttachFile: FC<AttachFileProps> = ({ setValue }) => {
  const [fileList, setFileList] = useState<File[] | null>();

  const handleOnChange = async (files?: File[]) => {
    const promises = files?.map(async (file) => {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          const base64String = reader.result?.toString().split(',')[1];

          resolve({ fileName: file.name, contentType: file.type, data: base64String });
        };
      });
    });

    if (promises) {
      const base64Files = await Promise.all(promises);

      setValue?.('attachments', base64Files);
    } else {
      setValue?.('attachments', files);
    }
  };

  const handleSeletcFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      const newFileList = Array.from(e.target.files);
      handleOnChange?.(newFileList);
      setFileList(newFileList);
    } else {
      setFileList(undefined);
      handleOnChange?.(undefined);
    }
  };

  const handleRemoveFile = (fileName?: string) => () => {
    setFileList((prev) => {
      const newFileList = prev?.filter((file) => file.name !== fileName);
      handleOnChange?.(newFileList);
      return newFileList;
    });
  };

  return (
    <div className="attach-file">
      <label htmlFor="attach-file" className="attach-file__label">
        Possui algum anexo? (opcional)
      </label>
      <span className="attach-file__text">
        Se você possuir alguma evidência que ajude na sua explicação pode anexar aqui. São aceitos arquivos em .pdf,
        .jpg com no máximo 50mb.
      </span>
      <div className="attach-file__input">
        <span className="attach-file__input__icon">
          <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7.9 10.2966H9.49V15.2966C9.49 15.8466 9.94 16.2966 10.49 16.2966H14.49C15.04 16.2966 15.49 15.8466 15.49 15.2966V10.2966H17.08C17.97 10.2966 18.42 9.2166 17.79 8.5866L13.2 3.9966C12.81 3.6066 12.18 3.6066 11.79 3.9966L7.2 8.5866C6.57 9.2166 7.01 10.2966 7.9 10.2966ZM5.5 19.2966C5.5 19.8466 5.95 20.2966 6.5 20.2966H18.5C19.05 20.2966 19.5 19.8466 19.5 19.2966C19.5 18.7466 19.05 18.2966 18.5 18.2966H6.5C5.95 18.2966 5.5 18.7466 5.5 19.2966Z"
              fill="black"
            />
          </svg>
        </span>
        <span className="attach-file__input__text">Selecione o arquivo</span>
        <input type="file" id="attach-file" onChange={handleSeletcFile} data-testid="attach-file" multiple />
      </div>

      {!!fileList && fileList.length && (
        <div className="attach-file__file-list">
          {fileList.map((file) => {
            return (
              <div className="attach-file__file" key={file.name}>
                <span className="attach-file__file__bullet" />
                <div className="attach-file__file__desc">
                  <div className="attach-file__file__name">{file?.name || 'lalala'}</div>
                  <div className="attach-file__file__size">Tamanho total: - {getSizeByFile(file)}</div>
                </div>
                <button
                  type="button"
                  className="attach-file__file__remove"
                  aria-label="Remover"
                  onClick={handleRemoveFile(file?.name)}
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M18.3 5.70971C18.1131 5.52246 17.8595 5.41723 17.595 5.41723C17.3305 5.41723 17.0768 5.52246 16.89 5.70971L12 10.5897L7.10997 5.69971C6.92314 5.51246 6.66949 5.40723 6.40497 5.40723C6.14045 5.40723 5.8868 5.51246 5.69997 5.69971C5.30997 6.08971 5.30997 6.71971 5.69997 7.10971L10.59 11.9997L5.69997 16.8897C5.30997 17.2797 5.30997 17.9097 5.69997 18.2997C6.08997 18.6897 6.71997 18.6897 7.10997 18.2997L12 13.4097L16.89 18.2997C17.28 18.6897 17.91 18.6897 18.3 18.2997C18.69 17.9097 18.69 17.2797 18.3 16.8897L13.41 11.9997L18.3 7.10971C18.68 6.72971 18.68 6.08971 18.3 5.70971Z"
                      fill="#333333"
                    />
                  </svg>
                </button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

AttachFile.defaultProps = {
  setValue: undefined,
};
